"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ProductTexts = void 0;

var _react = _interopRequireDefault(require("react"));

var ProductTexts = function ProductTexts(_ref) {
  var title = _ref.title,
      description = _ref.description,
      status = _ref.status;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: status === 'current_product' ? 'product-title product-current' : 'product-title'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-description"
  }, description));
};

exports.ProductTexts = ProductTexts;